import { adminListingQueryKeys as e } from "./adminListingQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminListingsApi as n } from "@maat/api-main";
//#region src/listings/admin/useAdminListingImagesQuery.ts
var r = (r) => t({
	queryKey: e.images(r),
	queryFn: () => n.getListingImages(r),
	enabled: !!r
});
//#endregion
export { r as useAdminListingImagesQuery };
